import {
  PendingActionsOutlined,
  RunningWithErrorsOutlined,
  SaveAsOutlined,
} from "@mui/icons-material";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import React from "react";
import { IInvoiceStatistics } from "../interfaces/invoice/IInvoice";
import { lightPalette } from "../mui/palettes";

export const getInvoiceStatusIcon = (status: keyof IInvoiceStatistics) => {
  if (status === "overdue") {
    return <RunningWithErrorsOutlined fill={lightPalette.primary.main} />;
  }
  if (status === "paid") {
    return <PaidOutlinedIcon fill={lightPalette.primary.main} />;
  }
  if (status === "pending") {
    return <PendingActionsOutlined fill={lightPalette.primary.main} />;
  }
  return <SaveAsOutlined fill={lightPalette.primary.main} />;
};
